import { render, staticRenderFns } from "./OrderingSubjectList.vue?vue&type=template&id=e467e50c&scoped=true&"
import script from "./OrderingSubjectList.vue?vue&type=script&lang=ts&"
export * from "./OrderingSubjectList.vue?vue&type=script&lang=ts&"
import style0 from "./OrderingSubjectList.vue?vue&type=style&index=0&id=e467e50c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e467e50c",
  null
  
)

export default component.exports